import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';

import { env } from './EnvironmentConfig';

export const APP_NAME = 'Awele';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const ROSA_API_ENDPOINT_URL = env.ROSA_API_ENDPOINT_URL;
export const ROSA_API_BEARER_TOKEN = env.ROSA_API_BEARER_TOKEN;
export const AMPLITUDE_API_KEY = env.AMPLITUDE_API_KEY;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const BOOKING_PREFIX_PATH = '/booking';
export const REVIEW_PREFIX_PATH = '/review';

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light',
  direction: DIR_LTR,
};
